import { render, staticRenderFns } from "./AvatarWithTitleAndAction.vue?vue&type=template&id=416e72a0&"
import script from "./AvatarWithTitleAndAction.vue?vue&type=script&lang=js&"
export * from "./AvatarWithTitleAndAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports